import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { BoletoFormModel } from 'model/api/gestao/boleto/boleto-add-form-model';
import { useSessaoAtual } from 'services/app';
import { ContaBancariaConfiguracaoModel } from 'model/api/gestao/conta-bancaria-configuracao/conta-bancaria-configuracao-model';

export function usePutContaBancariaConfiguracao() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<BoletoFormModel>();
    const { getEmpresa } = useSessaoAtual();

    const empresaId = getEmpresa().Id;

    const putContaBancariaConfiguracao = useCallback(
        (contaBancariaId: string, model: ContaBancariaConfiguracaoModel) =>
            invocarApi({
                method: 'PUT',
                url: `/${VariaveisAmbiente.apiVersion}/empresa/${empresaId}/conta-bancaria/${contaBancariaId}/configuracao-boleto/${model.id}`,
                data: {
                    ...model,
                    empresaId: empresaId
                },
                enviarTokenUsuario: true
            }),
        [empresaId, invocarApi],
    );
    return {
        ...outrasPropriedades,
        putContaBancariaConfiguracao,
    };
}